module.exports = __webpack_public_path__ + "static/media/P1.b0d0e47d.png";